import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import CircularProgress from "@mui/material/CircularProgress";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PeopleIcon from "@mui/icons-material/People";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import Logo1 from "../../assets/header_crm_logo.webp";

function OwnerLogin() {
    const navigate = useNavigate();
    const no = atob(localStorage.getItem("number"));
    const bid = localStorage.getItem("branch_id");
    const [mobileno, setMobileno] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // Function to fetch user data after successful login
    const fetchUserData = async (userId, branchId, token) => {
        try {
            const response = await axios.get(
                `${config.apiUrl}/api/swalook/get_current_user/?id=${no}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (response.data.status && response.data.current_user_data) {
                const userData = response.data.current_user_data;

                // Store important data in localStorage
                localStorage.setItem("profile_pic", userData.profile_pic || "");
                localStorage.setItem("mobile_no", userData.mobile_no || "");
                localStorage.setItem("review_link", userData.review || "");

                console.log(
                    "Additional user data fetched and saved:",
                    userData
                );
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    const handleAdminLogin = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            const response = await axios.post(
                `${config.apiUrl}/api/swalook/centralized/login/`,
                { mobileno, password }
            );

            if (response.data.error.message === "login successful!") {
                // Block login if type is "staff-mobile"
                if (response.data.data.type === "staff-mobile") {
                    toast.error(
                        "Staff-mobile login is not permitted. Please contact administrator."
                    );
                    setLoading(false);
                    return;
                }

                // Set cookies
                Cookies.set("loggedIn", "true", { expires: 10 });
                Cookies.set("type", response.data.data.type, { expires: 10 });
                const salonName = response.data.data.salon_name;
                Cookies.set("salonName", salonName, { expires: 10 });
                Cookies.set("branch_n", response.data.data.branch_name, {
                    expires: 10,
                });

                // Save all data to localStorage
                localStorage.setItem(
                    "branch_name",
                    btoa(response.data.data.branch_name)
                );
                localStorage.setItem("s-name", salonName);
                localStorage.setItem("type", response.data.data.type);
                localStorage.setItem(
                    "user",
                    JSON.stringify(response.data.data)
                );
                localStorage.setItem("token", response.data.data.token);
                localStorage.setItem("number", btoa(response.data.data.user));
                localStorage.setItem("branch_id", response.data.data.branch_id);

                // Save profile picture (image from API response)
                localStorage.setItem(
                    "profile_pic",
                    response.data.data.image || ""
                );

                // Save review link
                localStorage.setItem(
                    "review_link",
                    response.data.data.review || ""
                );
                localStorage.setItem("link", response.data.data.review || "");

                // Save timing information
                localStorage.setItem(
                    "in_time",
                    response.data.data.in_time || ""
                );
                localStorage.setItem(
                    "out_time",
                    response.data.data.out_time || ""
                );

                // Save additional user data that might be needed in PersonalInformation
                localStorage.setItem(
                    "mobile_no",
                    response.data.data.user || ""
                );
                localStorage.setItem(
                    "salon_name",
                    response.data.data.salon_name || ""
                );
                localStorage.setItem(
                    "branch_name_plain",
                    response.data.data.branch_name || ""
                );

                // Fetch additional user data after successful login
                await fetchUserData(
                    btoa(response.data.data.user), // userId
                    response.data.data.branch_id, // branchId
                    response.data.data.token // token
                );

                // Navigate based on user type
                if (response.data.data.type === "owner") {
                    navigate(`/${salonName}`);
                } else {
                    navigate(
                        `/${salonName}/${btoa(
                            response.data.data.branch_name
                        )}/dashboard`
                    );
                }

                console.log("Login successful! Data saved to localStorage:");
                console.log("Profile Picture:", response.data.data.image);
                console.log("Review Link:", response.data.data.review);
                console.log(
                    "Timings:",
                    response.data.data.in_time,
                    "-",
                    response.data.data.out_time
                );
            }
        } catch (error) {
            console.log(error);
            toast.error(
                "Invalid login credentials. Please check your credentials and try again."
            );
        } finally {
            setLoading(false);
        }
    };

    // Remove the useEffect that automatically fetches data on component mount
    // This will now only happen after successful login

    return (
        <div
            className="flex items-center justify-center min-h-screen bg-gray-100 px-4 py-8"
            style={{ zoom: 1.33 }}
        >
            <div className="relative w-full max-w-md p-6 bg-white rounded-lg shadow-md">
                <div className="flex justify-center mb-4">
                    <img src={Logo1} alt="Logo" className="h-44" />
                </div>
                <h1 className="text-xl font-semibold text-center text-gray-700 mb-4">
                    Welcome Back!
                </h1>

                <form onSubmit={handleAdminLogin} className="space-y-3">
                    <div>
                        <label
                            htmlFor="phone-number"
                            className="block text-gray-600 text-sm mb-1"
                        >
                            Phone Number
                        </label>
                        <div className="flex items-center border border-gray-300 rounded-md px-3 py-2 bg-gray-50">
                            <PhoneAndroidIcon className="text-gray-500 text-sm" />
                            <input
                                type="text"
                                id="phone-number"
                                className="ml-2 w-full outline-none bg-transparent text-sm"
                                placeholder="Enter phone number"
                                onChange={(e) => setMobileno(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label
                            htmlFor="password"
                            className="block text-gray-600 text-sm mb-1"
                        >
                            Password
                        </label>
                        <div className="flex items-center border border-gray-300 rounded-md px-3 py-2 bg-gray-50 relative">
                            <LockOpenIcon className="text-gray-500 text-sm" />
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                className="ml-2 w-full outline-none bg-transparent text-sm pr-8"
                                placeholder="Enter password"
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? (
                                    <VisibilityOff className="h-4 w-4 text-gray-400 hover:text-gray-600" />
                                ) : (
                                    <Visibility className="h-4 w-4 text-gray-400 hover:text-gray-600" />
                                )}
                            </button>
                        </div>
                    </div>

                    <p className="text-sm text-gray-500 text-center">
                        Forgot password?{" "}
                        <a href="#" className="text-blue-500 hover:underline">
                            Reset
                        </a>
                    </p>

                    <button
                        type="submit"
                        className="w-full flex items-center justify-center px-4 py-2 text-sm text-white bg-blue-500 rounded-md hover:bg-blue-600"
                    >
                        {loading ? (
                            <CircularProgress size={18} color="inherit" />
                        ) : (
                            "Login"
                        )}
                    </button>
                </form>

                {/* Staff Login Link - Mobile Only */}
                <div className="mt-4 md:hidden">
                    <Link
                        to="/staff/login"
                        className="w-full flex items-center justify-center gap-1 px-4 py-2 text-sm text-white bg-purple-500 rounded-md hover:bg-purple-600"
                    >
                        <PeopleIcon fontSize="small" />
                        Staff App
                    </Link>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
            />
        </div>
    );
}

export default OwnerLogin;
